"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunk6NZW4WK4js = require('./chunk-6NZW4WK4.js');

// src/checksum.ts
var _superstruct = require('superstruct');
var ChecksumStruct = _superstruct.size.call(void 0, 
  _chunk6NZW4WK4js.base64.call(void 0, _superstruct.string.call(void 0, ), { paddingRequired: true }),
  44,
  44
);



exports.ChecksumStruct = ChecksumStruct;
//# sourceMappingURL=chunk-E4C7EW4R.js.map